const DefaultBillNames = {
  electric: {
    cost1: 'Generation Cost',
    cost2: 'Distribution Cost',
    cost3: 'Other Costs',
    consumption1: 'Grid Purchased',
    consumption2: 'Solar Generation',
    consumption3: 'Solar Sellback',
    demand1: 'Metered',
    demand2: 'Billed',
  },
  gas: {
    cost1: 'Commodity Cost',
    cost2: 'Transmission Cost',
    consumption1: 'Usage',
  },
  water: {
    cost1: 'Water Cost',
    cost2: 'Sewer Cost',
    consumption1: 'Usage',
  },
  propane: {
    cost1: 'Total Cost',
    consumption1: 'Usage',
  },
  other: {
    consumption1: 'Usage',
    cost1: 'Total Cost',
  },
  production: {
    consumption1: 'Value',
  },
};

export default DefaultBillNames;
